import React, { useRef } from "react";
interface PriceCardProps {
    content: React.ReactNode
}

export const PriceCard: React.FC<PriceCardProps> = (
    {
        content
    }) => {
    return (
        <div style={{ display: "flex", justifyContent: "center", padding: 12 }}>
            <div className="card price-card">
                <div className="card-body" style={{ padding: "18px 20px 22px" }}>
                    {content}
                </div>
            </div>
        </div >
    )
}